import styled from 'styled-components'

export const StyledTradeButton = styled.button`
  align-items: center;
  background: ${({ theme }) => theme.colors.primary};
  border: none;
  border-radius: 48px;
  color: #ffffff;
  display: flex;
  flex-direction: row;
  font-size: 16px;
  font-weight: 500;
  justify-content: center;
  letter-spacing: 0.533333px;
  line-height: 140%;
  margin-top: 15px;
  outline: none;
  padding: 13px 0;
  text-align: center;
  width: 100%;
  cursor: pointer;

  &:disabled {
    background: ${({ theme }) => theme.colors.primaryDisabled};
    cursor: not-allowed;
  }

  .approve-lock {
    margin-left: 5px;
  }
`
